export { default, default as PrivacyPolicy } from "./PrivacyPolicy";
